export const EASYBIB = 'easybib' as const
export const CITATION_MACHINE = 'citationmachine' as const
export const BIBME = 'bibme' as const
export const CHEGG = 'chegg' as const
export const CITE_THIS_FOR_ME = 'citethisforme' as const

export const EB = 'eb'
export const CM = 'cm'
export const BM = 'bm'
export const CW = 'cw'
export const CTFM = 'ctfm'

export const EB_DOMAIN = '.easybib.com'
export const CM_DOMAIN = '.citationmachine.net'
export const BM_DOMAIN = '.bibme.org'
export const CW_DOMAIN = '.chegg.com'
export const CTFM_DOMAIN = '.citethisforme.com'

export const EB_PRODUCT_NAME = 'EasyBib'
export const CM_PRODUCT_NAME = 'Citation Machine'
export const BM_PRODUCT_NAME = 'BibMe'
export const CW_PRODUCT_NAME = 'Chegg Writing'
export const CTFM_PRODUCT_NAME = 'Cite This For Me'

export const siteToDomainMap = {
  [EASYBIB]: EB_DOMAIN,
  [CHEGG]: CW_DOMAIN,
  [CITATION_MACHINE]: CM_DOMAIN,
  [BIBME]: BM_DOMAIN,
  [CITE_THIS_FOR_ME]: CTFM_DOMAIN,
}

/*
  Super Auth profile code for all writing websites
*/
export enum SAProfileCode {
  CITATION_MACHINE = 'CM',
  BIBME = 'BM',
  EASYBIB = 'EB',
  CHEGG = 'CW',
  CITE_THIS_FOR_ME = 'CTFM',
}

export enum OAProfileCode {
  CITATION_MACHINE = 'CM',
  BIBME = 'BM',
  EASYBIB = 'EB',
  CHEGG = 'CW',
  CITE_THIS_FOR_ME = 'CTFM',
}

export enum SADefaultFlow {
  LOGIN = 'login',
  SIGN_UP = 'signup',
  FORGOT_PASSWORD = 'forgotpassword',
}

export enum SADisplay {
  INLINE = 'inline',
  DIALOG = 'dialog',
}

export enum SAAuthMethod {
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google',
  CHEGG = 'Chegg',
}

export enum SAAuthType {
  LOGIN = 'login',
  SIGN_UP = 'signup',
}
